// Generated by backend/scripts/sync-access-catalog.js. Edit backend/src/config/access-catalog.json.
export const ACCESS_CATALOG = {
  "version": 4,
  "panel": [
    {
      "key": "dashboard",
      "label": "Dashboard",
      "submodules": [
        {
          "key": "dashboard",
          "label": "Dashboard",
          "areas": [
            "dashboard"
          ],
          "url": "/admin/dashboard"
        }
      ]
    },
    {
      "key": "restaurantManagement",
      "label": "Outlet Management",
      "submodules": [
        {
          "key": "outlet.details",
          "label": "Details",
          "areas": [
            "outlet.details"
          ],
          "url": "/admin/my-restaurant"
        },
        {
          "key": "outlet.kitchens",
          "label": "Manage Kitchen",
          "areas": [
            "outlet.kitchens"
          ],
          "url": "/admin/kitchens"
        },
        {
          "key": "outlet.pos",
          "label": "Manage POS",
          "areas": [
            "outlet.pos"
          ],
          "url": "/admin/settings/pos-devices"
        },
        {
          "key": "outlet.users",
          "label": "Manage Users",
          "areas": [
            "outlet.users"
          ],
          "url": "/admin/settings/users"
        },
        {
          "key": "outlet.printSettings",
          "label": "Receipt Settings",
          "areas": [
            "outlet.printSettings"
          ],
          "url": "/admin/settings/print-settings"
        }
      ]
    },
    {
      "key": "menuManagement",
      "label": "Menu Management",
      "submodules": [
        {
          "key": "menu.categories",
          "label": "Categories & items",
          "areas": [
            "menu.categories"
          ],
          "url": "/admin/menu"
        },
        {
          "key": "menu.offers",
          "label": "Offers",
          "areas": [
            "menu.offers"
          ],
          "url": "/admin/offers"
        },
        {
          "key": "menu.coupons",
          "label": "Coupons",
          "areas": [
            "menu.coupons"
          ],
          "url": "/admin/coupons"
        },
        {
          "key": "menu.options",
          "label": "Options",
          "areas": [
            "menu.options"
          ],
          "url": "/admin/menu/option-groups"
        },
        {
          "key": "menu.mealDeals",
          "label": "Meal Deals",
          "areas": [
            "menu.mealDeals"
          ],
          "url": "/admin/meal-deals"
        },
        {
          "key": "menu.publish",
          "label": "Publish Menu",
          "areas": [
            "menu.publish"
          ],
          "kind": "action"
        },
        {
          "key": "menu.import",
          "label": "Import Menu with AI",
          "areas": [
            "menu.import"
          ],
          "kind": "action"
        }
      ]
    },
    {
      "key": "manageStocks",
      "label": "Manage Stocks",
      "submodules": [
        {
          "key": "stock.overview",
          "label": "Overview",
          "areas": [
            "stock.overview"
          ],
          "url": "/admin/inventory"
        },
        {
          "key": "stock.onHand",
          "label": "Stock on hand",
          "areas": [
            "stock.onHand"
          ],
          "url": "/admin/inventory/stock"
        },
        {
          "key": "stock.purchases",
          "label": "Orders & deliveries",
          "areas": [
            "stock.purchases"
          ],
          "url": "/admin/inventory/purchase-orders"
        },
        {
          "key": "stock.counts",
          "label": "Stock counts",
          "areas": [
            "stock.counts"
          ],
          "url": "/admin/inventory/counts"
        },
        {
          "key": "stock.variance",
          "label": "Wastage & differences",
          "areas": [
            "stock.variance"
          ],
          "url": "/admin/inventory/variance"
        },
        {
          "key": "stock.storage",
          "label": "Dates & storage",
          "areas": [
            "stock.storage"
          ],
          "url": "/admin/inventory/dates"
        }
      ]
    },
    {
      "key": "inventoryAdmin",
      "label": "Inventory Admin",
      "submodules": [
        {
          "key": "inventory.recipes",
          "label": "Recipes & food cost",
          "areas": [
            "inventory.recipes"
          ],
          "url": "/admin/inventory/recipes"
        },
        {
          "key": "inventory.suppliers",
          "label": "Suppliers",
          "areas": [
            "inventory.suppliers"
          ],
          "url": "/admin/inventory/suppliers"
        },
        {
          "key": "inventory.items",
          "label": "Stock items",
          "areas": [
            "inventory.items"
          ],
          "url": "/admin/inventory/ingredients"
        },
        {
          "key": "inventory.groups",
          "label": "Groups & units",
          "areas": [
            "inventory.groups"
          ],
          "url": "/admin/inventory/categories"
        }
      ]
    },
    {
      "key": "tableManagement",
      "label": "Table Management",
      "submodules": [
        {
          "key": "tables.overview",
          "label": "Overview",
          "areas": [
            "tables.overview"
          ],
          "url": "/admin/table-booking"
        },
        {
          "key": "tables.diary",
          "label": "Diary",
          "areas": [
            "tables.diary"
          ],
          "url": "/admin/table-booking/diary"
        },
        {
          "key": "tables.floors",
          "label": "Floor Management",
          "areas": [
            "tables.floors"
          ],
          "url": "/admin/table-booking/floor-management"
        },
        {
          "key": "tables.settings",
          "label": "Booking Settings",
          "areas": [
            "tables.settings"
          ],
          "url": "/admin/table-booking/settings"
        }
      ]
    },
    {
      "key": "marketing",
      "label": "Marketing",
      "submodules": [
        {
          "key": "marketing.whatsapp",
          "label": "WhatsApp campaigns",
          "areas": [
            "marketing.whatsapp"
          ],
          "url": "/admin/marketing/whatsapp"
        },
        {
          "key": "marketing.creatives",
          "label": "Creative library",
          "areas": [
            "marketing.creatives"
          ],
          "url": "/admin/marketing/creatives"
        },
        {
          "key": "marketing.brand",
          "label": "Brand kit",
          "areas": [
            "marketing.brand"
          ],
          "url": "/admin/marketing/brand"
        },
        {
          "key": "marketing.send",
          "label": "Send campaigns and record permission",
          "kind": "action",
          "areas": [
            "marketing.send"
          ]
        },
        {
          "key": "marketing.export",
          "label": "Export campaign reports",
          "kind": "action",
          "areas": [
            "marketing.export"
          ]
        }
      ]
    },
    {
      "key": "reporting",
      "label": "Reports",
      "submodules": [
        {
          "key": "reports.sales",
          "label": "Sales",
          "areas": [
            "reports.sales"
          ],
          "url": "/admin/reports/sales"
        },
        {
          "key": "reports.menu",
          "label": "Menu performance",
          "areas": [
            "reports.menu"
          ],
          "url": "/admin/reports/menu"
        },
        {
          "key": "reports.payments",
          "label": "Payments & cash",
          "areas": [
            "reports.payments"
          ],
          "url": "/admin/reports/payments"
        },
        {
          "key": "reports.inventory",
          "label": "Inventory",
          "areas": [
            "reports.inventory"
          ],
          "url": "/admin/reports/inventory"
        },
        {
          "key": "reports.customers",
          "label": "Customers",
          "areas": [
            "reports.customers"
          ],
          "url": "/admin/reports/customers"
        }
      ]
    },
    {
      "key": "legal",
      "label": "Legal",
      "submodules": [
        {
          "key": "legal.privacy",
          "label": "Privacy Policy",
          "areas": [
            "legal.privacy"
          ],
          "url": "/admin/legal?tab=privacy"
        },
        {
          "key": "legal.terms",
          "label": "Terms & Conditions",
          "areas": [
            "legal.terms"
          ],
          "url": "/admin/legal?tab=terms"
        }
      ]
    }
  ],
  "app": [
    {
      "key": "mobileApp",
      "label": "Mobile App",
      "submodules": [
        {
          "key": "mobileApp.dashboard",
          "label": "Dashboard",
          "areas": [
            "mobileApp.dashboard"
          ]
        },
        {
          "key": "mobileApp.manageMenu",
          "label": "Manage Menu",
          "areas": [
            "mobileApp.manageMenu"
          ]
        },
        {
          "key": "mobileApp.reports",
          "label": "Reports",
          "areas": [
            "mobileApp.reports"
          ]
        },
        {
          "key": "mobileApp.onlineOrders",
          "label": "Online Orders",
          "areas": [
            "mobileApp.onlineOrders"
          ]
        },
        {
          "key": "mobileApp.marketing",
          "label": "Marketing",
          "areas": [
            "mobileApp.marketing"
          ]
        },
        {
          "key": "mobileApp.tableOrder",
          "label": "Table Order",
          "areas": [
            "mobileApp.tableOrder"
          ]
        },
        {
          "key": "mobileApp.mobileOrder",
          "label": "Mobile Order",
          "areas": [
            "mobileApp.mobileOrder"
          ]
        }
      ]
    },
    {
      "key": "onlineOrder",
      "label": "Online Order",
      "submodules": [
        {
          "key": "onlineOrder.onlineOrder",
          "label": "Online Order",
          "areas": []
        }
      ]
    }
  ]
} as const;
